import constants from './constants';

const initState = {
  createEditClient: {
    celsia_id: '',
    third_id: '',
    description: '',
    stratum: 1,
    business_type_id: '',
    representative: false,
    devices_id: '',
  },
  clientIdToEdit: null,
  clientView: null,
  clientDashboard: null,
};

function clientReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_CREATE_EDIT_CLIENT:
      return {
        ...state,
        createEditClient: payload,
      };

    case constants.SET_CLIENT_ID_TO_EDIT:
      return {
        ...state,
        clientIdToEdit: payload,
      };
    case constants.SET_VIEW_CLIENT:
      return {
        ...state,
        clientView: payload,
      };
    case constants.SET_DASHBOARD_CLIENT:
      return {
        ...state,
        clientDashboard: payload,
      };

    default:
      return state;

  }

}

export default clientReducer;
